module.exports = __webpack_public_path__ + "static/media/cancel.f1294bc2.svg";